// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xv_a bib_vp bib_vh bib_xe bib_rg bib_tr bib_qx"};